<template>
  <ul class="pro-flex-list">
    <li class="pro" v-for="(item,index) in handleData" :key="index" :class="item.image_url?'active'+' '+row:'not'+' '+row">
      <template v-if="item.image_url">
        <router-link :to="{name:'detail',params: {goodsId:item.id}}">
          <div class="pro-img">
            <img v-lazy="item.image_url" alt :key="item.image_url">
          </div>
          <div class="pro-info">
            <div class="title">{{item.name}}</div>
            <div class="desc">{{item.brief}}</div>
          </div>
          <div class="price">￥{{item.price}}元</div>
        </router-link>
        <div class="pro-collet-icon pro-handle-icon" @click="changeFav(item.id)">
          <i class="icon iconfont iconcollete" title="收藏"></i>
          <!-- <span>收藏</span> -->
        </div>
        <div class="pro-addcart-icon pro-handle-icon" @click="addToCart(item.product.id)">
          <!-- <span>加入购物车</span> -->
          <i class="icon iconfont iconcart" title="添加到购物车"></i>
        </div>
      </template>
    </li>
  </ul>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'ProductRowOne',
  components: {},
  props: {
    row: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    handleData() {
      let data = this.list
      data.forEach(() => {
        let list = data.length
        let num = list % 5
        if (num !== 0) {
          for (let i = 0; i < 5 - num; i++) {
            data.push({})
          }
        }
      })
      return this.list
    },
  },
  methods: {
    ...mapActions(['getCartNumsAction']),
    //切换收藏
    changeFav(id) {
      let data = {
        goods_id: id,
      }
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
        }
      })
    },
    addToCart(id) {
      let data = {
        product_id: id,
        nums: 1,
      }
      this.$api.addCart(data).then(res => {
        if (res.status) {
          this.$notify({
            title: '加入购物车成功',
            type: 'success',
            offset: 100,
            duration: 2500,
            dangerouslyUseHTMLString: true,
            message: `<a href="#/cart" style="background:#FF7159;color:#FFF;font-size:12px;padding:5px 22px;">去结算</a>`,
          })
          this.getCartNums()
        }
      })
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data)
        }
      })
    },
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variable.scss';
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  .pro {
    position: relative;
    width: 100%;
    // margin-bottom: 14px;
    padding: 20px;
    background: #fff;
    transition: all 0.25s linear;
    box-sizing: border-box;
    &.row-4 {
      width: 24%;
    }
    &.not {
      &.not {
        background: $theme-bg;
      }
    }
    // &.active:hover {
    //   transform: translateY(-3px);
    //   box-shadow: 1px 1px 20px #999;
    //   .pro-handle-icon {
    //     display: block;
    //   }
    // }
    &.active{
      border-bottom: 1px solid #e5e5e5;
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      .pro-img {
        width: 100px;
        height: 100px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .pro-info {
        margin-left: 20px;
        width: 400px;
        .title {
          font-size: 16px;
          line-height: 18px;
          font-weight: 400;
          color: #666;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .desc {
          margin: 10px 0;
          line-height: 15px;
          font-size: 12px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #b0b0b0;
        }
      }
      .price {
        font-size: 16px;
        width: 150px;
        color: $price;
        margin-left: 20px;
        text-align: center;
        height: 18px;
        line-height: 18px;
      }
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  position: absolute;
  height: 24px;
  top: 14px;
  right: 10px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    right: 50px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}
</style>